// extracted by mini-css-extract-plugin
export default {"current":"br_gr","update":"br_gs","showColors":"br_gt","positive":"br_gv","negative":"br_gw"};